export var AuthRoute;
(function (AuthRoute) {
    AuthRoute["FINISH_SIGN_UP"] = "finishSignUp";
    AuthRoute["RESET_PASSWORD"] = "resetPassword";
    AuthRoute["JOIN_OFFICE"] = "joinOffice";
    AuthRoute["SIGNUP"] = "signup";
})(AuthRoute || (AuthRoute = {}));
//# sourceMappingURL=routes.js.map